<template>
  <!-- 一级 -->
  <el-checkbox-group v-model="roleIdData.ids">
    <div
      :style="{ height: !isExt[index] ? 'auto' : '20px' }"
      class="list"
      v-for="(i, index) in list"
      :key="index"
    >
      <!-- 如果当前i的roleID ,我的isExt数组里没有，那就是展开的 -->
      <div class="item-list">
        <i
          @click="isExtFun(index)"
          v-if="i.roleList && !isExt[index]"
          class="el-icon-caret-bottom"
        ></i>
        <i
          @click="isExtFun(index)"
          v-else-if="i.roleList"
          class="el-icon-caret-right"
        ></i>
        <el-checkbox :label="i.roleId"></el-checkbox>
        <span @click="isExtFun(index)" class="title">{{ i.name }}</span>
      </div>
      <!-- 二级数据 -->
      <treeItem :list="i.roleList" />
    </div>
  </el-checkbox-group>
</template>
<script>
import { reactive } from "vue";
import roleIdData from "../sateJs/roleId.js";
export default {
  name: "treeItem",
  props: {
    list: Array,
  },
  setup() {
    //   console.log(roleIdData)
    let isExt = reactive([]);
    const isExtFun = (index) => {
      // isExt.push(id)
      // isExt[index] == true
      isExt[index] = !isExt[index];
    };
    return {
      isExt,
      isExtFun,
      roleIdData,
    };
  },
};
</script>
<style lang="scss" scoped>
.list {
  padding-left: 20px;
  overflow: hidden;
  line-height: 20px;
  cursor: pointer;
  //   padding:20px;
  span.title {
    font-size: 14px;
    margin-left: 10px;
    color: #333;
  }
}
.list .item-list:hover {
  background-color: #efefef;
}
</style>
<style>
.list /deep/ .el-checkbox__label {
  display: none;
}
.list /deep/ i {
  font-size: 16px;
  color: #999;
}
</style>